import React, { useState, useEffect } from 'react';
import userFeedbackService from '../../services/feedback.service';
import PropTypes from 'prop-types';


function Feedback(props) {
    const {  show, CustomerId , PartnerId ,assetId, onCancelClick }= props;
    const [formData, setFormData] = useState({
        rating: 0,
        message: '',
        cancellationReason: 0
    });

    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        let timer;
        if (submitted) {
            timer = setTimeout(() => {
                setSubmitted(false);
            }, 3000); 
        }

        return () => {
            clearTimeout(timer); 
        };
    }, [submitted]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleRating = (ratingValue) => {
        setFormData((prevData) => ({
            ...prevData,
            rating: ratingValue,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.rating || !formData.message || formData.cancellationReason === '0') {
            return;
        }
        await userFeedbackService.postUserFeedback(formData, CustomerId ?? 0, PartnerId , assetId ?? 0)
            .then(response => {
                setSubmitted(true);
                setFormData({ rating: 0, message: '' , cancellationReason: 0 });
                handleClose();

            }).catch(e => {
                setSubmitted(true);
                setFormData({ rating: 0, message: '' , cancellationReason: 0 });
                handleClose();
            });
    };

    const handleClose = () => {
        if (onCancelClick) {
            onCancelClick();
        }
    };

    return (
        <div className="modal " style={{ display: show ? "block" : "none" }}>
            <div className="modal-wrapper"
                 style={{
                     transform: show ? 'translateY(0vh)' : 'translateY(-100vh)',
                     opacity: show ? '1' : '0'
                 }}>

                <div className="modal-header">
                    <h3>Feedback</h3>
                    <span className="close-modal-btn" onClick={handleClose}>×</span>
                </div>
                <form onSubmit={handleSubmit} className="feedback-container">
                    <StarRating rating={formData.rating} onRatingChange={handleRating} />
                    <select
                        name="cancellationReason"
                        value={formData.cancellationReason}
                        onChange={handleChange}
                       className="feedback-drpdown"
                    >
                        <option value="0">Cancellation reason</option>
                        <option value="1">Moved</option>
                        <option value="2">Cost of service too high</option>
                        <option value="3">Service value too low</option>
                    </select>
                    <textarea
                        name="message"
                        placeholder="Your Feedback"
                        value={formData.message}
                        onChange={handleChange}
                       className="feedback-textarea"
                    />

                    <div className="feedback-actions">
                        {submitted && <p className="feedback-success">Thank you for your feedback!</p>}
                        <button className="secondary-btn btn-small btn-float-right" type="submit">
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

Feedback.propTypes = {
    show: PropTypes.bool.isRequired,
    CustomerId: PropTypes.number,
    PartnerId: PropTypes.number,
    assetId: PropTypes.number,
    onCancelClick: PropTypes.func.isRequired,
};

const StarRating = ({ rating, onRatingChange, totalStars = 5 }) => {
    const [hover, setHover] = useState(0);

    return (
        <div className="star-rating-container">
            {[...Array(totalStars)].map((_, index) => {
                const starValue = index + 1;
                const isActive = starValue <= (hover || rating);

                return (
                    <span key={index} className={`star ${isActive ? 'star-active' : 'star-inactive'}`} onClick={() => onRatingChange(starValue)} onMouseEnter={() => setHover(starValue)} onMouseLeave={() => setHover(0)} role="button" tabIndex="0" onKeyDown={(e) => {if (e.key === 'Enter' || e.key === ' ') {onRatingChange(starValue);}}} aria-label={`Rate ${starValue} out of ${totalStars} stars`}>
                        &#9733;
                    </span>
                );
            })}
        </div>
    );
};

export default Feedback;
